// Klingon translations
export const tlh = {
  // Navigation
  'nav.overview': "leghqa'",
  'nav.dashboard': 'Dajchaj',
  'nav.analytics': 'nInatlh',
  'nav.reportingDashboard': 'QIn Dajchaj',
  'nav.sales': "lanchu'",
  'nav.salesOrders': "lanchu'mey",
  'nav.purchase': 'ghItlh',
  'nav.purchaseOrders': "ghItlh lanchu'mey",
  'nav.purchaseReview': "legh mu'ghom",
  'nav.purchase.sprints': 'Sprintmey',
  'nav.supplierOnboarding': 'Suppliyaw chel',
  'nav.po': 'PO',
  'nav.po.sprints': 'Sprintmey',
  'nav.po.newSprint': "Sprint chu'",
  'nav.scout': 'Scout',
  'nav.scout.wochenplanung': 'Wochenplanung',
  'nav.scout.tagesplanung': 'Tagesplanung',
  'nav.scout.prequal': 'PreQual jach',
  'nav.scout.missionen': 'Missionmey',
  'nav.scout.missionControl': 'Mission ChoHwI',
  'nav.scout.unternehmenssuche': 'nej QeD',
  'nav.scout.preferences': 'ChoHwI',
  'nav.scout.hilfe': 'QaH',
  'nav.scout.scorecard': 'Scorecard',
  'nav.poSprints': 'PO/Sprintmey',
  'nav.wiki': 'Wiki',
  'nav.supportVisualization': 'Support legh',
  'nav.navigationTiles': 'Nav tilemey',
  'nav.styleGuide': 'StyleGuide',
  'nav.inventory': 'Lager',
  'nav.items': 'ngogh',
  'nav.warehouse': 'Warehouse',
  'nav.picking': 'Picking',
  'nav.asn': 'ASN',
  'nav.returns': 'Returns',
  'nav.accounting': 'Accounting',
  'nav.accountsReceivable': 'AccountsReceivable',
  'nav.crm': 'CRM',
  'nav.leads': 'Leads',
  'nav.contacts': 'Contactmey',
  'nav.ai': 'AI',
  'nav.commandCenter': 'ra\'wI\' Dajchaj',
  'nav.workflows': 'Workflowmey',
  'nav.workflowManagement': 'Workflow ChoHwI',
  'nav.projectManagement': 'Project ChoHwI',
  'nav.support': 'Support',
  'nav.tickets': 'Ticketmey',
  'nav.pivotTable': 'Pivot table',
  'nav.learning': 'Learning',
  'nav.curriculumPlanning': 'Curriculum plan',
  'nav.learnerDashboard': 'Learner Dajchaj',
  'nav.accessibleLearnerDashboard': 'Accessible Learner Dajchaj',
  'nav.settings': 'ChoHwI',
  'nav.general': 'General',
  'nav.company': 'QeD',
  'nav.addressManagement': 'Address ChoHwI',
  'nav.usersRoles': "loHpu' & Rolemey",
  'nav.auditLog': 'Audit log',
  'nav.integrations': 'Integrationmey',
  'nav.appOverview': "leghqa' App",
  'nav.appOverviewDescription': "App legh 'ej tilemey choH.",
  'header.help': 'QaH',
  'header.account': 'Account',
  'header.portalName': 'CLANDA Portal',
  'header.preferences': 'ChoHwI',
  'header.language': 'Hol',
  'header.notifications.title': 'ghach Dun',
  'header.notifications.empty': 'QIn pagh',
  'header.notifications.markAllRead': 'Hoch pagh laS',
  'header.notifications.enablePrompt': 'Push ghach Dun?',
  'header.notifications.enableCta': 'Dun',

  // Help page
  'action.delete': 'Qaw',
  'message.success': 'Qapla\'',
  'message.error': 'Qagh',
  'common.yes': "HIja'",
  'common.no': "ghobe'",
  'common.cancel': "Ha'",
  'common.confirm': 'QIch',
  'common.save': 'chel',
  'common.saveChanges': 'chel choH',
  'common.close': 'SoH',
  'common.reset': "Ha'",
  'common.back': 'qab',
  'common.loading': "ta'...",
  'common.search': 'nej',
  'common.search.placeholder': 'nej...',
  'common.filter': 'Suy',
  'common.sort': 'Sort',
  'common.add': 'ngogh',
  'common.delete': 'Qaw',
  'common.edit': 'ghItlh',
  'common.error': 'Qagh',
  'common.remove': 'Qaw',
  'common.minutesShort': '{{value}} Min',
  'common.na': 'N/A',
  'common.days': 'jajmey',
  'common.status.active': 'active',
  'common.status.paused': 'paused',
  'common.status.stopped': 'stopped',
  'common.status.pending': 'pending',
  'common.status.completed': 'completed',
  'common.status.planned': 'Planned',
  'common.status.inProgress': 'In Progress',
  'common.status.done': 'Done',
  'common.apply': 'chel',
  'common.actions.filter': 'Suy',
  'common.actions.export': 'Export',
  'common.actions.search': 'nej',
  'common.dialog.defaultTitle': 'Dialog',
  'common.all': 'logh',
  'common.total': "mIw'a'",
  'common.pending': 'Pending',
  'common.assigned': 'Assigned',
  'common.inProgress': 'In Progress',
  'common.completed': 'Completed',
  'common.cancelled': 'Cancelled',
  'common.approved': 'Approved',
  'common.rejected': 'Rejected',
  'common.processing': 'Processing',
  'common.overdue': 'Overdue',
  'common.partial': 'Partial',
  'common.highPriority': 'High Priority',
  'common.tableView': 'Table legh',
  'common.cardView': 'Card legh',
  'common.switchToTable': 'Switch to table',
  'common.switchToCard': 'Switch to card',
  'common.openMenu': 'Menu poS',
  'common.details': 'legh',
  'common.new': "chu'",
  'common.draft': 'Draft',
  'common.shipped': 'Shipped',
  'common.delivered': 'Delivered',
  'common.received': 'Received',
  'common.inTransit': 'In Transit',
  'common.itemsPicked': 'Items Picked',
  'common.totalRefund': 'Total Refund',
  'common.totalPrice': 'Total price',
  'common.orderSummary': 'Order Summary',
  'common.subtotal': 'Subtotal:',
  'common.tax': 'Tax:',
  'common.discount': 'Discount:',
  'common.totalColon': "mIw'a':",
  'dateRange.today': 'DaHjaj',
  'dateRange.yesterday': "wa'leS",
  'dateRange.last7Days': 'Last 7 jajmey',
  'dateRange.last14Days': 'Last 14 jajmey',
  'dateRange.last30Days': 'Last 30 jajmey',
  'dateRange.thisMonth': 'This month',
  'dateRange.custom': 'Custom',
  'widget.vsLastPeriod': 'vs last period',
  'table.showing': 'Showing',
  'table.of': 'of',
  'table.page': 'ghIt',
  'table.previous': 'qab',
  'table.next': 'next',
  'table.filterGroups': 'filter groups',
  'table.addFilterGroup': 'add filter group',
  'table.filterGroup': 'filter group',
  'table.addCondition': 'add condition',
  'table.operator': 'operator',
  'table.field': 'field',
  'table.noFilterGroups': 'no filter groups.',
  'filter.operator.equals': 'equals',
  'filter.operator.not_equals': 'does not equal',
  'filter.operator.contains': 'contains',
  'filter.operator.not_contains': 'does not contain',
  'filter.operator.starts_with': 'starts with',
  'filter.operator.ends_with': 'ends with',
  'filter.operator.gt': 'greater than',
  'filter.operator.lt': 'less than',
  'filter.operator.gte': 'at least',
  'filter.operator.lte': 'at most',
  'filter.operator.between': 'between',
  'filter.operator.in': 'is one of',
  'filter.operator.not_in': 'is not one of',
  'filter.operator.is_set': 'is set',
  'filter.operator.is_not_set': 'is not set',
  'filter.placeholder.value': 'value',
  'filter.placeholder.min': 'min',
  'filter.placeholder.max': 'max',
  'filter.placeholder.select': 'select…',
  'filter.placeholder.selectMultiple': 'select values…',
  'filter.logic.and': 'AND',
  'filter.logic.or': 'OR',

  'settings.title': 'Account ChoHwI',
  'consent.title': 'Consent',
  'consent.label': 'Terms \'ej ordering policy.',
  'consent.description': 'Terms read \'ej accept.',
  'consent.required': 'Terms consent.',
  'consent.link.terms': 'Terms',
  'contacts.title': 'Contactmey',
  'contacts.role': 'Role',
  'contacts.role.admin': 'Admin',
  'contacts.role.billing': 'Billing',
  'contacts.role.technical': 'Technical',
  'contacts.role.other': 'Other',
  'auth.callback.title': 'Authentication',


  'learning.feed.greeting': 'Hello {{name}}!',
  'learning.feed.levelInfo': 'Level {{level}} • {{xp}} XP',
  'learning.feed.offline': 'Offline',
  'learning.feed.streakLabel': 'jaj streak',
  'learning.feed.dailyGoal': 'Daily goal',
  'learning.feed.recommendedLessons': 'Recommended lessons',
  'learning.feed.priority.high': 'High',
  'learning.feed.priority.medium': 'Medium',
  'learning.feed.priority.low': 'Low',
  'learning.feed.difficulty.easy': 'Easy',
  'learning.feed.difficulty.medium': 'Medium',
  'learning.feed.difficulty.hard': 'Hard',
  'learning.feed.aiRecommendation': 'AI recommendation',
  'learning.feed.actions.start': 'Start',
  'learning.feed.actions.skip': 'Skip',
  'learning.feed.actions.reload': 'Reload',
  'learning.feed.empty.title': 'All lessons completed!',
  'learning.feed.empty.description': 'All lessons today. Come back tomorrow!',
  'learning.quiz.title': 'Quiz',
  'learning.quiz.questionCounter': 'Question {{current}} of {{total}}',
  'learning.quiz.options.true': 'True',
  'learning.quiz.options.false': 'False',
  'learning.quiz.actions.next': 'Next',
  'learning.quiz.actions.finish': 'Finish',
  'learning.quiz.actions.retry': 'Try again',
  'learning.quiz.badge.xp': '{{xp}} XP',
  'learning.quiz.badge.time': '{{seconds}}s',
  'learning.quiz.result.passedTitle': 'Quiz passed!',
  'learning.quiz.result.failedTitle': 'Quiz not passed',
  'learning.quiz.result.scoreSummary': '{{correct}} of {{total}} correct',
  'learning.quiz.result.xpEarned': '+{{xp}} XP earned',
  'learning.quiz.result.answersHeading': 'Detailed answers',
  'learning.quiz.result.questionLabel': 'Question {{index}}',
  'learning.quiz.result.yourAnswer': 'Your answer',
  'learning.quiz.result.correctAnswer': 'Correct answer',
  'learning.lessonCard.difficulty.easy': 'Easy',
  'learning.lessonCard.difficulty.medium': 'Medium',
  'learning.lessonCard.difficulty.hard': 'Hard',
  'learning.lessonCard.status.completed': 'Completed',
  'learning.lessonCard.reward': 'Reward',
  'learning.lessonCard.progress': 'Progress',
  'learning.lessonCard.selectFormat': 'Format wIv',
  'learning.lessonCard.prerequisites': 'Prerequisites',
  'learning.lessonCard.actions.start': 'Start',
  'learning.lessonCard.actions.repeat': 'Repeat',
  'learning.lessonCard.actions.pause': 'Pause',
  'learning.lessonCard.actions.complete': 'Complete',
  'learning.lessonCard.actions.bookmark': 'Bookmark',
  'learning.lessonCard.actions.unbookmark': 'Remove bookmark',
  'learning.lessonCard.actions.collapse': 'Collapse',
  'learning.lessonCard.actions.expand': 'Expand',
  'learning.lessonCard.goalLabel': 'Goal',
  'learning.lessonCard.formats.video': 'Watch video',
  'learning.lessonCard.formats.text': 'Read text',
  'learning.lessonCard.formats.audio': 'Listen audio',
  'learning.lessonCard.formats.cheatSheet': 'Cheat sheet',
  'learning.lessonCard.formatUnknown': 'Unknown',
  'learning.accessible.title': 'Learning Dajchaj',
  'learning.accessible.welcome': 'Welcome back, {{name}}',
  'learning.accessible.voice.start': 'Voice',
  'learning.accessible.voice.stop': 'Stop listening',
  'learning.accessible.voice.listening': 'Listening...',
  'learning.accessible.level': 'Level',
  'learning.accessible.xpToNext': '{{value}} XP next level',
  'learning.accessible.streak': 'Streak',
  'learning.accessible.days': '{{value}} jajmey',
  'learning.accessible.keepItUp': 'Keep it up!',
  'learning.accessible.badges': 'Badges',
  'learning.accessible.achievementsEarned': 'Achievements',
  'learning.accessible.tabs.overview': "leghqa'",
  'learning.accessible.tabs.lessons': 'Lessons',
  'learning.accessible.tabs.progress': 'Progress',
  'learning.accessible.tabs.achievements': 'Achievements',
  'learning.accessible.recentActivity': 'Recent Activity',
  'learning.accessible.noRecentActivity': 'No activity',
  'learning.accessible.start': 'Start',
  'learning.accessible.learningProgress': 'Learning Progress',
  'learning.accessible.overallProgress': 'Overall Progress',
  'learning.accessible.achievements': 'Achievements',
  'learning.accessible.startingLesson': 'Starting lesson {{id}}',
  'learning.accessible.difficulty.beginner': 'Beginner',
  'learning.accessible.difficulty.intermediate': 'Intermediate',
  'learning.accessible.difficulty.advanced': 'Advanced',

  'gamification.xpToast.xpLabel': 'XP',
  'gamification.xpToast.streakProgress': 'Streak progress',
  'gamification.xpToast.streakProgressValue': '{{current}} / {{target}}',
  'gamification.xpToast.source.lesson': 'Lesson',
  'gamification.xpToast.source.quiz': 'Quiz',
  'gamification.xpToast.source.streak': 'Streak',
  'gamification.xpToast.source.badge': 'Badge',
  'gamification.xpToast.source.bonus': 'Bonus',
  'gamification.xpToast.levelUp.title': 'Level Up!',
  'gamification.xpToast.levelUp.description': 'Level {{level}}!',
  'gamification.xpToast.levelUp.xpEarned': '+{{xp}} XP earned',
  'gamification.xpToast.button.continue': 'Continue',
  'gamification.xpToast.streakMilestone.title': 'Streak milestone!',
  'gamification.xpToast.streakMilestone.description': '{{count}}-jaj streak!',
  'gamification.xpToast.streakMilestone.bonus': '+{{xp}} XP bonus',
  'gamification.close': 'SoH',
  'knowledgeBase.back': 'qab',
  'knowledgeBase.article.view': 'legh',
  'knowledgeBase.article.views': '{{count}} views',
  'knowledgeBase.article.helpful': '{{count}} helpful',
  'knowledgeBase.article.notHelpful': '{{count}} not helpful',
  'knowledgeBase.article.byAuthor': 'By {{author}}',
  'knowledgeBase.header.title': 'Knowledge Base',
  'knowledgeBase.header.subtitle': 'nej answers',
  'knowledgeBase.actions.filter': 'Suy',
  'knowledgeBase.actions.sort': 'Sort',
  'knowledgeBase.search.placeholder': 'nej knowledge base...',
  'knowledgeBase.tabs.all': 'logh',
  'knowledgeBase.stats.popular': 'Popular articles',
  'knowledgeBase.stats.viewsCount': '{{count}} views',
  'knowledgeBase.stats.helpful': 'Helpful articles',
  'knowledgeBase.stats.ratingsCount': '{{count}} ratings',
  'knowledgeBase.stats.total': 'Total articles',
  'knowledgeBase.stats.totalCount': '{{count}} articles',
  'knowledgeBase.empty.title': 'No articles',
  'knowledgeBase.empty.searching': 'Try different search.',
  'knowledgeBase.empty.default': 'No articles category.',
  'knowledgeBase.difficulty.beginner': 'Beginner',
  'knowledgeBase.difficulty.intermediate': 'Intermediate',
  'knowledgeBase.difficulty.advanced': 'Advanced',
  'knowledgeBase.categories.odoo-basics': 'Odoo basics',
  'knowledgeBase.categories.crm': 'CRM & Sales',
  'knowledgeBase.categories.inventory': 'Inventory & Procurement',
  'knowledgeBase.categories.accounting': 'Accounting',
  'knowledgeBase.categories.projects': 'Project management',
  'knowledgeBase.categories.troubleshooting': 'Troubleshooting',
  'curriculum.video': 'Video',
  'curriculum.videoDescription': 'Screen recording',
  'curriculum.cheatSheet': 'Cheat Sheet',
  'curriculum.cheatSheetDescription': 'Print-ready, QR',
  'curriculum.test': 'Test/Quiz',
  'curriculum.testDescription': 'Odoo survey, 10, 80%',
  'curriculum.checklist': 'Checklist',
  'curriculum.checklistDescription': 'Odoo tasks',
  'curriculum.textLesson': 'Text/Lesson',
  'curriculum.textLessonDescription': 'Odoo lesson',
  'curriculum.roleplay': 'Roleplay',
  'curriculum.roleplayDescription': 'Live mentor',
  'curriculum.practice': 'Practice Task',
  'curriculum.practiceDescription': 'Perform customer',

  'scout.wochenplanung.title': "Week leghqa'",
  'scout.wochenplanung.previousWeek': 'Previous week',
  'scout.wochenplanung.nextWeek': 'Next week',
  'scout.wochenplanung.toast.appointmentAdded': "Appointment ngoghpu'",
  'scout.wochenplanung.toast.appointmentAddedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentUpdated': "Appointment choHpu'",
  'scout.wochenplanung.toast.appointmentUpdatedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentDeleted': "Appointment Qawpu'",
  'scout.wochenplanung.toast.slotUpdated': "Slot choHpu'",
  'scout.wochenplanung.toast.slotUpdatedDesc': 'Mission resolve or slot Qaw.',
  'scout.wochenplanung.legend.completed': 'completed',
  'scout.wochenplanung.legend.planned': 'planned',
  'scout.wochenplanung.legend.partial': 'partial',
  'scout.wochenplanung.legend.unplanned': 'unplanned',
  'scout.wochenplanung.legend.holiday': 'Holiday',
  'scout.wochenplanung.dialog.deleteAppointment.title': 'Qaw appointment',
  'scout.wochenplanung.dialog.deleteAppointment.description': 'Qaw this appointment?',
  'scout.wochenplanung.dialog.editAppointment.title': 'ghItlh appointment',
  'scout.wochenplanung.dialog.editAppointment.description': 'choH this appointment?',
  'scout.wochenplanung.employee': 'Employee',
  'scout.wochenplanung.selectEmployee': 'Employee wIv',
  'scout.wochenplanung.allEmployees': 'All employees',
  'scout.wochenplanung.error.loading': 'Qagh loading',
  'scout.wochenplanung.error.retry': 'Try again',
  'scout.missions.industries.placeholder': 'Industries wIv',
  'scout.missions.industries.search': 'nej industries...',
  'scout.missions.industries.empty': 'No industries',
  'scout.missions.products.placeholder': 'Product families wIv',
  'scout.missions.products.search': 'nej products...',
  'scout.missions.products.empty': 'No products',
  'scout.missionControl.tabs.team': "Team leghqa'",
  'scout.missionControl.teamMembers': 'Team members',
  'scout.missionControl.table.employee': 'Employee',
  'scout.missionControl.table.team': 'Team',
  'scout.missionControl.table.plzAreas': 'PLZ areas',
  'scout.missionen.bestandskunden.loadError': 'Qagh load bestandskunden',
  'scout.missionen.bestandskunden.empty': 'No bestandskunden',
  'scout.missionen.bestandskunden.search': 'maqoch Sam...',
  'scout.missionen.bestandskunden.filteredCount': '{{total}} maqochmey {{filtered}}',
  'scout.missionen.wunschliste.industriesTitle': 'Preferred industries',
  'scout.missionen.wunschliste.productsTitle': 'Preferred products',
  'scout.missionen.wunschliste.plzTitle': 'Preferred PLZ',
  'scout.missionen.wunschliste.saveButton': 'chel',
  'scout.missionen.wunschliste.saved': "chelpu'",
  'scout.missionen.wunschliste.savedDesc': "Preferences chelpu'",
  'scout.missionen.wunschliste.saveError': 'Qagh',
  'scout.missionen.wunschliste.saveErrorDesc': 'Preferences not chel',
  'scout.missionen.wunschliste.loadError': 'Qagh load preferences',
  'scout.tagesplanung.title': 'Daily Planning',
  'scout.tagesplanung.addressUnknown': 'Address unknown',
  'scout.tagesplanung.routeMapLabel': 'Route map',
  'scout.tagesplanung.routePlanning': 'Route planning',
  'scout.tagesplanung.traffic': 'Traffic',
  'scout.tagesplanung.deferNotPossible': 'Defer not possible',
  'scout.tagesplanung.deferMaxReached': 'Max defers today (3/3).',
  'scout.tagesplanung.deferAlreadyDeferred': 'Lead already deferred today.',
  'scout.tagesplanung.dayCannotClose': 'Day cannot SoH',
  'scout.tagesplanung.outstandingReports': '{{count}} outstanding reports. Fill before SoH day.',
  'scout.tagesplanung.andMore': '... and {{count}} more',
  'scout.tagesplanung.tabs.planning': 'Daily plan',
  'scout.tagesplanung.tasks.tabLabel': 'Tasks',
  'scout.tagesplanung.tasks.empty': 'No tasks',
  'scout.tagesplanung.tasks.loading': 'Loading tasks',
  'scout.tagesplanung.tasks.error': 'Could not load tasks',
  'scout.tagesplanung.tasks.filterFieldStatus': 'Status',
  'scout.tagesplanung.tasks.filterStatusTodo': 'To do',
  'scout.tagesplanung.tasks.filterStatusInProgress': 'In progress',
  'scout.tagesplanung.tasks.filterStatusDone': 'Done',
  'scout.tagesplanung.tasks.priorityLabel': 'Priority',
  'scout.tagesplanung.tasks.priorityValue': '{{value}}',
  'scout.tagesplanung.tasks.priorityUnknown': '—',
  'scout.tagesplanung.tasks.dueLabel': 'Due',
  'scout.tagesplanung.tasks.dueNone': 'No due date',
  'scout.lead.neukunde': 'Neukunde',
  'scout.lead.bestandskunde': 'Bestandskunde',
  'scout.metrics.besuche': 'Visits',
  'scout.metrics.demos': 'Demos',
  'scout.metrics.auftraege': 'Orders',
  'scout.metrics.umsatz': 'Revenue',
  'scout.metrics.demoRate': 'Demo rate',
  'scout.composition.title': 'Mission composition',
  'scout.composition.minBestandskunden': 'Min Bestandskunden',
  'scout.composition.minQualifiziert': 'Min Qualified',
  'scout.composition.maxKaltbesuche': 'Max cold visits',
  'scout.dailyPlanning.addAppointment': 'ngogh Appointment',
  'scout.dailyPlanning.appointments': 'Appointments',
  'scout.dailyPlanning.noAppointmentsPlanned': 'No appointments day',
  'scout.dailyPlanning.leadsByPriority': 'Leads (priority)',
  'scout.dailyPlanning.noLeadsPlanned': 'No leads day',
  'scout.dailyPlanning.skipLead': 'Skip lead',
  'scout.dailyPlanning.skipLeadConfirmation': 'Skip this lead? Next day.',
  'scout.dailyPlanning.skip': 'Skip',
  'scout.dailyPlanning.removeLead': 'Qaw lead',
  'scout.dailyPlanning.removeLeadConfirmation': 'Qaw this lead? Remove rotation.',
  'scout.dailyPlanning.selectMissionToViewLeads': 'Mission wIv legh leads',
  'scout.dailyPlanning.selectDate': 'Date wIv',
  'scout.dailyPlanning.nextDay': 'Next day',
  'scout.dailyPlanning.closeDay': 'SoH day',
  'scout.dailyPlanning.reopenDay': 'Reopen day',
  'scout.dailyPlanning.noAcceptedLeads': 'No accepted leads day.',
  'scout.dailyPlanning.statusSkipped': 'Skipped',
  'scout.dailyPlanning.selectAll': 'Select logh',
  'scout.dailyPlanning.selectAllLeads': 'Select logh leads',
  'scout.dailyPlanning.noSuggestions': 'No suggestions.',
  'scout.dailyPlanning.previousDay': 'Previous day',
  'scout.dailyPlanning.calendarWeek': 'Calendar week {{weekNumber}}',
  'scout.dailyPlanning.visit': 'Visit',
  'scout.dailyPlanning.details': 'legh',
  'scout.dailyPlanning.missionsLoading': 'Loading missionmey…',
  'scout.dailyPlanning.leadsLoading': 'Loading leads…',
  'scout.dailyPlanning.noLeadsFound': 'No leads',
  'scout.dailyPlanning.moreLeads': 'latlh',
  'scout.dailyPlanning.dailyList': 'Daily list',
  'scout.dailyPlanning.unknown': 'Unknown',
  'scout.dailyPlanning.suggestedLeads': 'Suggested leads',
  'scout.dailyPlanning.error': 'Qagh: {{error}}',
  'scout.dailyPlanning.help': 'QaH',
  'scout.dailyPlanning.bulkActions': 'Bulk actions',
  'scout.dailyPlanning.actionsCount': 'Actions ({{count}})',
  'scout.dailyPlanning.accept': 'Accept',
  'scout.dailyPlanning.reject': 'Reject',
  'scout.dailyPlanning.selectLead': 'Select lead {{name}}',
  'scout.dailyPlanning.openLeadDetails': 'legh {{name}}',
  'scout.dailyPlanning.score': 'Score: {{score}}',
  'scout.dailyPlanning.loading': 'Loading daily planning',

  'scout.scorecard.selectHeatmapMetric': 'Heatmap metric wIv',
  'scout.scorecard.orders': 'Orders',
  'scout.scorecard.annualTargetOrders': 'Annual target orders',
  'scout.scorecard.comingSoon': 'Coming soon',
  'scout.scorecard.kpiOverview': 'KPI leghqa\'',
  'scout.scorecard.activityByDay': 'Activity by day',
  'scout.scorecard.title': 'Scorecard',
  'scout.scorecard.period.tag': 'Day',
  'scout.scorecard.period.woche': 'Week',
  'scout.scorecard.period.monat': 'Month',
  'scout.scorecard.period.jahr': 'Year',
  'scout.scorecard.kpiTilesHeading': 'KPI tiles',
  'scout.scorecard.topBranchenProdukteHeading': 'Top industries products',
  'scout.scorecard.soll': 'Soll',
  'scout.scorecard.forecast': 'Forecast',
  'scout.scorecard.gapToGo': 'Gap-to-Go',
  'scout.scorecard.csvExport': 'CSV Export',
  'scout.scorecard.pdfExport': 'PDF Export',
  'scout.scorecard.table.date': 'Date',
  'scout.scorecard.table.visits': 'Visits',
  'scout.scorecard.table.demos': 'Demos',
  'scout.scorecard.table.orders': 'Orders',
  'scout.scorecard.table.60l': '60L',
  'scout.scorecard.table.25l': '25L',
  'scout.scorecard.table.10l': '10L',
  'scout.scorecard.table.netRevenue': 'Net revenue',
  'scout.scorecard.table.total': "mIw'a'",
  'scout.scorecard.topBranchen': 'Top industries',
  'scout.scorecard.topProdukte': 'Top products',
  'scout.scorecard.table.industry': 'Industry',
  'scout.scorecard.table.quantity': 'Quantity',
  'scout.scorecard.table.revenue': 'Revenue (€)',
  'scout.scorecard.table.product': 'Product',
  'scout.scorecard.table.salesVolume': 'Sales volume',
  'scout.scorecard.table.customers': 'Customers',
  'scout.scorecard.kpi.visits': 'Visits',
  'scout.scorecard.kpi.demos': 'Demos',
  'scout.scorecard.kpi.orders': 'Orders',
  'scout.scorecard.kpi.netRevenue': 'Net revenue',
  'scout.scorecard.kpi.gebinde60l': '60L',
  'scout.scorecard.kpi.gebinde25l': '25L',
  'scout.scorecard.kpi.gebinde10l': '10L',
  'scout.scorecard.emptyTitle': 'No data',
  'scout.scorecard.emptyDescription': 'No KPI data period.',
  'scout.scorecard.missionPerformanceTitle': 'Mission Performance',
  'scout.scorecard.missionMissionsCompleted': 'Missions completed',
  'scout.scorecard.missionConversionRate': 'Conversion rate',
  'scout.scorecard.missionTerritoryCoverage': 'Territory coverage',
  'scout.scorecard.viewMissionDetails': 'legh details',
  'scout.scorecard.adjustTargets': 'Adjust targets',
  'scout.scorecard.annualTarget': 'Annual target',
  'scout.scorecard.annualTargetVisits': 'Annual target visits',
  'scout.scorecard.annualTargetDemos': 'Annual target demos',
  'scout.scorecard.annualTargetNetRevenue': 'Net revenue (€)',
  'scout.scorecard.annualTargetNetRevenueA11y': 'Annual target net revenue €',
  'scout.scorecard.monthlyOverrides': 'Monthly overrides',
  'scout.scorecard.table.month': 'Month',
  'scout.scorecard.table.reason': 'Reason',
  'scout.scorecard.derivedTargets': 'Derived targets',
  'scout.scorecard.dailyTargetLabel': 'Daily target: {{count}} visits',
  'scout.scorecard.weeklyTargetLabel': 'Weekly target: {{count}} visits',
  'scout.scorecard.save': 'chel',
  'scout.scorecard.heatmap.visits': 'Visits',
  'scout.scorecard.heatmap.demos': 'Demos',
  'scout.scorecard.heatmap.revenue': 'Revenue',
  'scout.scorecard.heatmap.low': 'Low',
  'scout.scorecard.heatmap.high': 'High',
  'scout.scorecard.heatmap.scaleA11y': 'Scale low high',
  'scout.scorecard.heatmap.loading': 'Map loading…',

  'scout.missionControl.teamOverview': 'Team PLZ areas',
  'scout.missionControl.jokerLimitPerDay': 'Joker limit / day',
  'scout.missionControl.jokerLimitUpdated': 'Joker limit choHpu\'',
  'scout.missionControl.jokerLimitSaveFailed': 'Joker limit not chel',
  'scout.missionControl.selectTeam': 'Team wIv',
  'scout.missionControl.none': 'None',
  'scout.missionControl.addPlzAreaFor': 'ngogh PLZ area for',
  'scout.missionControl.addPlzArea': 'ngogh PLZ area',
  'scout.missionControl.noTeamMembersFound': 'No team members.',
  'scout.missionControl.orders': 'Orders',
  'scout.missionControl.resetSettings': 'Ha\' ChoHwI',
  'scout.missionControl.saveSettings': 'chel ChoHwI',
  'scout.missionControl.territorySaturation': 'Territory saturation (PLZ)',
  'scout.missionControl.day': 'Day',
  'scout.missionControl.selectDay': 'Day wIv',
  'scout.missionControl.week': 'Week',
  'scout.missionControl.selectWeek': 'Week wIv',
  'scout.missionControl.month': 'Month',
  'scout.missionControl.selectMonth': 'Month wIv',
  'scout.missionControl.planFulfillment': 'Plan fulfillment',
  'scout.missionControl.plzPrefixPlaceholder': 'PLZ prefix (e.g. 70)',
  'scout.missionControl.plzPrefix': 'PLZ prefix',
  'scout.missionControl.addPlzToWhitelist': 'ngogh PLZ whitelist',
  'scout.missionControl.addPlzToGreylist': 'ngogh PLZ greylist',
  'scout.missionControl.addPlzToYellowlist': 'ngogh PLZ yellowlist',
  'scout.missionControl.addNewTeamMember': 'ngogh team member',
  'scout.missionControl.lastModified': 'Last modified',
  'scout.missionControl.outsideAreaRules': 'Outside area rules',
  'scout.missionControl.outsidePlzPolicy': 'PLZ outside policy',
  'scout.missionControl.enableOutsideWarning': 'Outside PLZ warning',
  'scout.missionControl.requireOutsideApproval': 'Outside PLZ approval',
  'scout.missionControl.rejectOutsidePlz': 'Reject outside PLZ',
  'scout.missionControl.checkPlz': 'Check PLZ',
  'scout.missionControl.check': 'Check',
  'scout.missionControl.error': 'Qagh',
  'scout.missionControl.success': 'Qapla\'',
  'scout.missionControl.userProfileNotFound': 'User profile not found',
  'scout.missionControl.plzAreasUpdated': 'PLZ areas choHpu\'',
  'scout.missionControl.plzAreasSaveFailed': 'PLZ areas not chel',
  'scout.missionControl.repConfig.title': 'Rep config',
  'scout.missionControl.repConfig.repName': 'Name / Email',
  'scout.missionControl.repConfig.industries': 'Industries',
  'scout.missionControl.repConfig.products': 'Products',
  'scout.missionControl.repConfig.plz': 'PLZ',
  'scout.missionControl.repConfig.loadError': 'Rep config not load',
  'scout.missionControl.repConfig.saveError': 'chel Qagh',
  'scout.missionControl.repConfig.savedTitle': "chelpu'",
  'scout.missionControl.repConfig.savedDesc': 'Rep config choHpu\'',
  'scout.missionControl.jokerConfig.title': 'Joker limit per day',
  'scout.missionControl.jokerConfig.description': 'Max joker per rep per day.',
  'scout.missionControl.jokerConfig.maxPerDay': 'Max per day',
  'scout.missionControl.jokerConfig.loadError': 'Joker config not load',
  'scout.missionControl.jokerConfig.saveError': 'chel Qagh',
  'scout.missionControl.jokerConfig.savedTitle': "chelpu'",
  'scout.missionControl.jokerConfig.savedDesc': 'Joker limit choHpu\'',
  'scout.missionControl.diagnostics.demoRate': 'Demo rate',
  'scout.missionControl.diagnostics.visitDepth': 'Visit depth',

  'scout.unternehmenssuche.selectAllResults': 'Select logh results',
  'scout.unternehmenssuche.openingHours': 'OPENING HOURS',
  'scout.unternehmenssuche.temporarilyClosed': 'Temporarily closed',
  'scout.unternehmenssuche.startSearch': 'Start nej',
  'scout.search.selectStatus': 'Status wIv...',
  'scout.unternehmenssuche.searchRunning': 'nej running...',
  'scout.unternehmenssuche.adjustSearchCriteria': 'Adjust criteria or try again.',
  'scout.unternehmenssuche.selectCompanyType': 'Company type wIv',
  'scout.unternehmenssuche.openingHoursTime': 'Opening time',
  'scout.unternehmenssuche.noTimeNeeded': 'No time needed',
  'scout.unternehmenssuche.addConditions': 'ngogh conditions',
  'scout.unternehmenssuche.addCondition': 'ngogh condition',
  'scout.unternehmenssuche.addGroup': 'ngogh group',
  'scout.unternehmenssuche.savedSearchName': 'Saved search name',
  'scout.unternehmenssuche.saveCurrentSearch': 'chel current nej',
  'scout.unternehmenssuche.savedSearches': 'Saved searches',
  'scout.unternehmenssuche.noSavedSearches': 'No saved searches.',
  'scout.unternehmenssuche.keywordPlaceholder': 'e.g. Restaurant, Bar',
  'scout.unternehmenssuche.addWaypoint': 'ngogh waypoint',
  'scout.unternehmenssuche.locationPlaceholder': 'e.g. Munich',
  'scout.unternehmenssuche.toggleAdditionalFilters': 'Toggle filters',
  'scout.unternehmenssuche.additionalFilters': 'Additional filters',
  'scout.unternehmenssuche.saveSearchAsFile': 'chel nej file',
  'scout.unternehmenssuche.loadSearchFromFile': 'Load nej file',
  'scout.unternehmenssuche.checkSearchTerms': 'Check terms or try again.',
  'search.overlay.hint': 'Type and Enter or click nej.',
  'search.overlay.placeholder': 'nej (/) resources docs',
  'search.overlay.searchLabel': 'nej',
  'search.overlay.noResults': 'No results "{{query}}"',
  'search.overlay.tryDifferent': 'Try different terms.',
  'search.overlay.topResults': 'Top results',
  'search.overlay.documentation': 'Documentation · ',
  'scout.unternehmenssuche.locationRadius': 'Location + radius',
  'scout.unternehmenssuche.routeCorridor': 'Route + corridor',
  'scout.unternehmenssuche.withoutLocation': 'Without location',
  'scout.scorecard.heatmapTitle': 'Activity heatmap (PLZ-2)',
  'scout.preferences.defaultRegionLabel': 'Default region',
  'scout.preferences.selectRegionPlaceholder': 'Region wIv',
  'scout.preferences.defaultStatusLabel': 'Default status',
  'scout.preferences.selectDefaultStatus': 'Default status wIv',
  'scout.preferences.statusDraft': 'Draft',
  'scout.preferences.statusActive': 'Active',
  'scout.preferences.statusCompleted': 'Completed',
  'scout.preferences.statusArchived': 'Archived',
  'scout.preferences.saving': 'Saving...',
  'scout.preferences.plzPrefixes': 'PLZ prefixes missionmey',
  'scout.preferences.plzPrefixesPlaceholder': 'PLZ comma (e.g. 70, 71)',
  'scout.preferences.maxRouteLength': 'Max route (km)',
  'scout.preferences.maxRouteLengthDescription': 'Max route km',
  'scout.preferences.autoGenerateMissions': 'Auto generate (night)',
  'scout.preferences.autoGenerateDescription': 'Auto generate from ChoHwI.',
  'scout.preferences.defaultAssigneeLabel': 'Default assignee',
  'scout.preferences.defaultAssigneePlaceholder': 'Assignee ghoS',
  'scout.preferences.defaultAssigneeAria': 'Default assignee',
  'scout.preferences.defaultLeadCountLabel': 'Default lead count',
  'scout.preferences.defaultLeadCountAria': 'Default lead count',
  'scout.preferences.defaultDurationLabel': 'Default duration (days)',
  'scout.preferences.defaultDurationAria': 'Default duration days',
  'scout.preferences.autoAssignLabel': 'Auto assign default',
  'scout.preferences.productFamiliesLabel': 'Product families',
  'scout.preferences.industryCodesLabel': 'Industries',
  'scout.preferences.keywordsLabel': 'Keywords',
  'scout.preferences.keywordsPlaceholder': 'e.g. beton, estrich',
  'scout.preferences.minLeadsLabel': 'Min leads mission',
  'scout.preferences.minLeadsAria': 'Min leads mission',
  'scout.preferences.maxLeadsLabel': 'Max leads mission',
  'scout.preferences.maxLeadsAria': 'Max leads mission',
  'scout.preferences.dailyQuotaLabel': 'Missions per day',
  'scout.preferences.dailyQuotaAria': 'Max missions day',
  'scout.preferences.dailyQuotaHelper': 'Max auto missions day (1–3)',
  'scout.dailyPlanning.inField': 'In field',
  'scout.dailyPlanning.completed': 'Completed',
  'scout.dailyPlanning.openDay': 'Open day',
  'scout.dailyPlanning.dayMarkedCompleted': 'Day completed.',
  'scout.dailyPlanning.statusVisited': 'Visited',
  'scout.dailyPlanning.statusPlanned': 'Planned',
  'scout.dailyPlanning.statusCompleted': 'Completed',
  'scout.dailyPlanning.jokerAdd': 'Use joker',
  'scout.dailyPlanning.jokerTitle': 'Joker stop',
  'scout.dailyPlanning.jokerUsed': 'used',
  'scout.dailyPlanning.jokerLimitReached': 'Joker limit day.',
  'scout.dailyPlanning.jokerCompany': 'Company',
  'scout.dailyPlanning.jokerCompanyPlaceholder': 'Company name ghoS',
  'scout.dailyPlanning.jokerReason': 'Reason',
  'scout.dailyPlanning.jokerReasonPlaceholder': 'Why this stop?',
  'scout.dailyPlanning.jokerCancel': "Ha'",
  'scout.dailyPlanning.jokerSubmit': 'Use joker',
  'scout.dailyPlanning.jokerCreateError': 'Joker stop not chu\'',
  'scout.createMission.title': "chu' Mission",
  'scout.createMission.description': 'Name, Suy, assign',
  'scout.createMission.nameLabel': 'Name',
  'scout.createMission.nameRequired': 'Name vaj',
  'scout.createMission.namePlaceholder': 'e.g. Stuttgart Nord',
  'scout.createMission.nameAria': 'Mission name',
  'scout.createMission.regionLabel': 'Region (vI\')',
  'scout.createMission.regionPlaceholder': 'e.g. PLZ 70xxx',
  'scout.createMission.regionAria': 'Region or PLZ',
  'scout.createMission.ownerLabel': 'Owner',
  'scout.createMission.ownerPlaceholder': 'Email',
  'scout.createMission.ownerAria': 'Owner email',
  'scout.createMission.themeLabel': 'Theme (vI\')',
  'scout.createMission.themePlaceholder': 'e.g. Kälteanlagen',
  'scout.createMission.themeAria': 'Mission theme',
  'scout.createMission.productLabel': 'Product (vI\')',
  'scout.createMission.productPlaceholder': 'e.g. K-2000',
  'scout.createMission.productAria': 'Product',
  'scout.createMission.cancel': "Ha'",
  'scout.createMission.save': 'chel',
  'scout.createMission.saveBusy': 'Saving…',
  'scout.createMission.cancelAria': "Ha' create",
  'scout.createMission.saveAria': 'chel mission',
  'scout.createMission.saveBusyAria': 'Saving mission',

  'settings.description': 'Manage app ChoHwI',
  'settings.typography.title': 'Typography',
  'settings.typography.description': 'Text size density',
  'settings.typography.scale.title': 'Text size',
  'settings.typography.scale.description': 'Standard or comfort',
  'settings.typography.scale.ariaLabel': 'Text size preset',
  'settings.typography.scale.compact': 'Compact',
  'settings.typography.scale.standard': 'Standard',
  'settings.typography.scale.comfort': 'Comfort',
  'settings.tabs.appearance': 'Appearance',
  'settings.tabs.account': 'Account',
  'settings.tabs.notifications': 'Notifications',
  'settings.tabs.security': 'Security',
  'settings.language.title': 'Language ChoHwI',
  'settings.language.description': 'Interface language wIv',
  'settings.language.interfaceLanguage': 'Interface language',
  'settings.language.interfaceLanguageDesc': 'Language menus buttons',
  'settings.theme.title': 'Theme',
  'settings.theme.description': 'Appearance colors',
  'settings.theme.predefinedThemes': '10 themes wIv?',
  'settings.theme.goToThemeSettings': 'Theme ChoHwI',
  'settings.themeSettings.title': 'Theme ChoHwI',
  'settings.themeSettings.description': 'Predefined themes',
  'settings.themeSettings.themeDetails': 'Theme legh',
  'settings.themeSettings.themeId': 'Theme ID:',
  'settings.themeSettings.colorScheme': 'Color scheme:',
  'settings.account.profile.title': 'Profile',
  'settings.account.profile.description': 'Update profile',
  'settings.account.profile.name': 'Name',
  'settings.account.profile.email': 'Email',
  'settings.account.profile.role': 'Role',
  'settings.account.profile.department': 'Department',
  'settings.account.profile.editProfile': 'ghItlh profile',
  'settings.account.data.title': 'Data',
  'settings.account.data.description': 'Sync backup',
  'settings.account.data.cloudSync': 'Cloud sync',
  'settings.account.data.cloudSyncEnabled': 'Settings sync cloud',
  'settings.account.data.cloudSyncDisabled': 'Cloud sync disabled',
  'settings.account.data.syncNow': 'Sync now',
  'settings.notifications.title': 'Notifications',
  'settings.notifications.description': 'How receive',
  'settings.notifications.email.title': 'Email notifications',
  'settings.notifications.email.description': 'Email receive',
  'settings.notifications.push.title': 'Push',
  'settings.notifications.push.description': 'Browser push',
  'settings.notifications.system.title': 'System',
  'settings.notifications.system.description': 'System alerts',
  'settings.notifications.configure': 'Configure',
  'settings.security.title': 'Security',
  'settings.security.description': 'Account security',
  'settings.security.password.title': 'Password',
  'settings.security.password.lastChanged': 'Changed 30 jajmey',
  'settings.security.password.change': 'Change',
  'settings.security.twoFactor.title': 'Two-factor',
  'settings.security.twoFactor.description': 'Extra security',
  'settings.security.twoFactor.enable': 'Enable',
  'settings.security.sessions.title': 'Sessions',
  'settings.security.sessions.description': 'Active sessions',
  'settings.security.sessions.view': 'legh sessions',
  'settings.company.title': 'Company',
  'settings.company.description': 'Company info',
  'settings.company.edit': 'ghItlh company',
  'settings.company.saveChanges': 'chel choH',
  'settings.company.cancel': "Ha'",
  'settings.company.tabs.general': 'General',
  'settings.company.tabs.contact': 'Contact',
  'settings.company.tabs.billing': 'Billing',
  'settings.company.tabs.branding': 'Branding',
  'settings.company.general.companyInfo': 'Company info',
  'settings.company.general.companyName': 'Company name',
  'settings.company.general.legalName': 'Legal name',
  'settings.company.general.taxId': 'Tax ID',
  'settings.company.general.registrationNumber': 'Registration',
  'settings.company.general.industry': 'Industry',
  'settings.company.general.foundedYear': 'Founded',
  'settings.company.general.employees': 'Employees',
  'settings.company.general.industry.technology': 'Technology',
  'settings.company.general.industry.manufacturing': 'Manufacturing',
  'settings.company.general.industry.retail': 'Retail',
  'settings.company.general.industry.healthcare': 'Healthcare',
  'settings.company.general.industry.finance': 'Finance',
  'settings.company.general.industry.other': 'Other',
  'settings.company.address.title': 'Address',
  'settings.company.address.street': 'Street',
  'settings.company.address.city': 'City',
  'settings.company.address.state': 'State',
  'settings.company.address.zipCode': 'ZIP',
  'settings.company.address.country': 'Country',
  'settings.company.address.country.us': 'United States',
  'settings.company.address.country.ca': 'Canada',
  'settings.company.address.country.uk': 'United Kingdom',
  'settings.company.address.country.de': 'Germany',
  'settings.company.address.country.fr': 'France',
  'settings.company.address.country.other': 'Other',
  'settings.company.contact.title': 'Contact',
  'settings.company.contact.phone': 'Phone',
  'settings.company.contact.email': 'Email',
  'settings.company.contact.website': 'Website',
  'settings.company.contact.supportEmail': 'Support email',
  'settings.company.billing.title': 'Billing',
  'settings.company.billing.currency': 'Currency',
  'settings.company.billing.taxRate': 'Tax rate (%)',
  'settings.company.billing.paymentTerms': 'Payment terms',
  'settings.company.billing.billingCycle': 'Billing cycle',
  'settings.company.billing.paymentTerms.net15': 'Net 15',
  'settings.company.billing.paymentTerms.net30': 'Net 30',
  'settings.company.billing.paymentTerms.net45': 'Net 45',
  'settings.company.billing.paymentTerms.net60': 'Net 60',
  'settings.company.billing.paymentTerms.dueOnReceipt': 'Due receipt',
  'settings.company.billing.cycle.monthly': 'Monthly',
  'settings.company.billing.cycle.quarterly': 'Quarterly',
  'settings.company.billing.cycle.annually': 'Annually',
  'settings.company.billing.cycle.custom': 'Custom',
  'settings.company.billing.summary.title': 'Billing summary',
  'settings.company.billing.summary.currentPlan': 'Current plan',
  'settings.company.billing.summary.monthlyCost': 'Monthly cost',
  'settings.company.billing.summary.nextBillingDate': 'Next billing',
  'settings.company.billing.summary.paymentMethod': 'Payment method',
  'settings.company.billing.summary.status': 'Status',
  'settings.company.billing.summary.active': 'Active',
  'settings.company.branding.title': 'Branding',
  'settings.company.branding.logo': 'Logo',
  'settings.company.branding.uploadLogo': 'Upload logo',
  'settings.company.branding.logoHint': 'PNG JPG 2MB',
  'settings.company.branding.favicon': 'Favicon',
  'settings.company.branding.uploadFavicon': 'Upload favicon',
  'settings.company.branding.faviconHint': 'ICO PNG 1MB',
  'settings.company.branding.primaryColor': 'Primary color',
  'settings.company.branding.secondaryColor': 'Secondary color',
  'settings.usersRoles.stats.totalUsers': 'Total users',
  'settings.usersRoles.stats.activeUsers': 'active users',
  'settings.usersRoles.stats.totalRoles': 'Total roles',
  'settings.usersRoles.stats.roleConfigurations': 'Role configs',
  'settings.userManagement.title': 'User management',
  'settings.userManagement.description': 'Users roles system',
  'settings.userManagement.addUser': 'ngogh user',
  'settings.userManagement.editUser': 'ghItlh user',
  'settings.userManagement.createNewUser': "chu' user",
  'settings.userManagement.updateUserInfo': 'Update user',
  'settings.userManagement.addNewUser': 'ngogh user system',
  'settings.userManagement.tabs.users': 'Users',
  'settings.userManagement.tabs.appAccess': 'App access',
  'settings.userManagement.tabs.roles': 'Roles',
  'settings.userManagement.toast.userCreated': 'User chu\'pu\'',
  'settings.userManagement.toast.userUpdated': 'User choHpu\'',
  'settings.userManagement.toast.userDeleted': 'User Qawpu\'',
  'settings.userManagement.toast.roleCreated': 'Role chu\'pu\'',
  'settings.userManagement.toast.roleUpdated': 'Role choHpu\'',
  'settings.userManagement.toast.roleDeleted': 'Role Qawpu\'',
  'settings.userManagement.toast.error': 'User not chu\'',
  'settings.userManagement.toast.errorUpdate': 'User not choH',
  'settings.userManagement.toast.errorDelete': 'User not Qaw',
  'settings.userManagement.toast.errorRoleCreate': 'Role not chu\'',
  'settings.userManagement.toast.errorRoleUpdate': 'Role not choH',
  'settings.userManagement.toast.errorRoleDelete': 'Role not Qaw',
  'settings.integrations.settings.security.enabled': 'Enabled',
  'settings.integrations.settings.security.disabled': 'Disabled',

  'crm.contacts.title': 'CRM Contactmey',
  'crm.contacts.description': 'Manage contacts',
  'crm.contacts.add': 'ngogh contact',
  'crm.contacts.edit': 'ghItlh contact',
  'crm.contacts.delete': 'Qaw contact',
  'crm.contacts.view360': '360° legh',
  'crm.contacts.unassigned': 'Unassigned',
  'crm.contacts.type.customer': 'Customer',
  'crm.contacts.type.supplier': 'Supplier',
  'crm.contacts.type.partner': 'Partner',
  'crm.contacts.type.prospect': 'Prospect',
  'crm.contacts.status.active': 'Active',
  'crm.contacts.status.inactive': 'Inactive',
  'crm.contacts.status.suspended': 'Suspended',
  'crm.contacts.validation.companyRequired': 'Company vaj',
  'crm.contacts.validation.streetRequired': 'Street vaj',
  'crm.contacts.validation.postalRequired': 'ZIP vaj',
  'crm.contacts.validation.cityRequired': 'City vaj',
  'crm.contacts.validation.countryRequired': 'Country vaj',
  'crm.contacts.validation.nameRequired': 'Name vaj',
  'crm.contacts.validation.emailInvalid': 'Email invalid',
  'crm.contacts.validation.phoneRequired': 'Phone vaj',
  'crm.contacts.validation.salesPersonRequired': 'Sales person vaj',
  'crm.contacts.validation.ordererNameRequired': 'Orderer vaj',
  'crm.contacts.validation.roleRequired': 'Role vaj',
  'crm.contacts.validation.hoursRequired': 'Hours vaj',
  'crm.openMenu': 'Menu poS',
  'crm.leads.title': 'Leads',
  'crm.leads.description': 'Manage leads',
  'crm.leads.add': 'ngogh lead',
  'crm.leads.edit': 'ghItlh lead',
  'crm.leads.delete': 'Qaw lead',
  'crm.leads.status.new': "chu'",
  'crm.leads.status.contacted': 'Contacted',
  'crm.leads.status.qualified': 'Qualified',
  'crm.leads.status.proposal': 'Proposal',
  'crm.leads.status.negotiation': 'Negotiation',
  'crm.leads.status.closedWon': 'Won',
  'crm.leads.status.closedLost': 'Lost',
  'crm.leads.source.website': 'Website',
  'crm.leads.source.referral': 'Referral',
  'crm.leads.source.email': 'Email',
  'crm.leads.source.phone': 'Phone',
  'crm.leads.source.social': 'Social',
  'crm.leads.source.other': 'Other',
  'crm.leads.value': 'Value',
  'crm.leads.lastContact': 'Last contact',
  'crm.leads.notes': 'Notes',
  'crm.leads.search': 'nej leads...',
  'crm.leads.filterByStatus': 'Status Suy',
  'crm.leads.filterBySource': 'Source Suy',
  'crm.leads.totalLeads': 'Total leads',
  'crm.leads.pipelineValue': 'Pipeline value',
  'crm.leads.qualifiedLeads': 'Qualified leads',

  'visitReport.title': 'Visit report',
  'visitReport.createTitle': "chu' visit report",
  'visitReport.titleFor': 'Visit report {{name}}',
  'visitReport.visitType': 'Visit type',
  'visitReport.coldVisit': 'Cold visit',
  'visitReport.appointment': 'Appointment',
  'visitReport.salesOutcome': 'Sales outcome',
  'visitReport.noContact': 'No contact',
  'visitReport.conversation': 'Conversation',
  'visitReport.demo': 'Demo',
  'visitReport.order': 'Order',
  'visitReport.orderValue': 'Order value (EUR)',
  'visitReport.nextStep': 'Next step',
  'visitReport.callback': 'Callback',
  'visitReport.sendOffer': 'ngeH offer',
  'visitReport.revisit': 'Revisit',
  'visitReport.completed': 'Completed',
  'visitReport.appointmentWindow': 'Window (vI\')',
  'visitReport.from': 'From',
  'visitReport.to': 'To',
  'visitReport.contactName': 'Contact name',
  'visitReport.enterName': 'Name ghoS',
  'visitReport.roleFunction': 'Role',
  'visitReport.enterRole': 'Role ghoS',
  'visitReport.isDecisionMaker': 'Decision maker?',
  'visitReport.decisionMakerName': 'DM name',
  'visitReport.decisionMakerRole': 'DM role',
  'visitReport.email': 'Email (vI\')',
  'visitReport.phone': 'Phone (vI\')',
  'visitReport.notes': 'Notes (vI\')',
  'visitReport.additionalInfo': 'Additional info...',
  'visitReport.productsDiscussed': 'Products discussed?',
  'visitReport.annualDemand': 'Annual demand',
  'visitReport.select': 'wIv',
  'visitReport.interest': 'Interest',
  'visitReport.interestHigh': 'high',
  'visitReport.interestMedium': 'medium',
  'visitReport.interestLow': 'low',
  'visitReport.modelFeedback': 'Model feedback?',
  'visitReport.feedbackYes': "HIja'",
  'visitReport.feedbackPartially': 'Partially',
  'visitReport.feedbackNo': "ghobe'",
  'visitReport.feedbackNotSeen': 'Not seen',
  'visitReport.branchCorrect': 'Branch correct? (vI\')',
  'visitReport.selectBranch': 'Branch wIv',
  'visitReport.branchConstruction': 'Construction',
  'visitReport.branchIndustry': 'Industry',
  'visitReport.branchTrade': 'Trade',
  'visitReport.branchService': 'Service',
  'visitReport.noInterestReason': 'No interest reason',
  'visitReport.wrongProduct': 'Wrong product',
  'visitReport.wrongTiming': 'Wrong timing',
  'visitReport.existingSupplier': 'Existing supplier',
  'visitReport.noBudget': 'No budget',
  'visitReport.noNeed': 'No need',
  'visitReport.decisionMakerNotReached': 'DM not reached',
  'visitReport.additionalRemarks': 'Remarks (vI\')',
  'visitReport.error': 'Qagh',
  'visitReport.validationError': 'Visit type \'ej outcome wIv.',
  'visitReport.deferralNotPossible': 'Defer not possible',
  'visitReport.maxDeferralReached': 'Last report deferred. Fill.',
  'visitReport.reportDeferred': 'Report deferred',
  'visitReport.deferralMessage': 'Fill later.',
  'visitReport.reportCreated': 'Report chu\'pu\'',
  'visitReport.reportSaved': 'Report chelpu\'',
  'visitReport.reportSavedFor': 'Report {{name}} chelpu\'',
  'visitReport.reportError': 'Report not chu\'',
  'visitReport.stepOf': 'Step {{current}} of {{total}}',
  'visitReport.back': 'qab',
  'visitReport.cancel': "Ha'",
  'visitReport.inAHurry': 'In a hurry',
  'visitReport.next': 'Next',
  'visitReport.saving': 'Saving...',
  'visitReport.finishVisit': 'Finish visit',
  'visitReport.contactNotes': 'Contact notes...',
  'visitReport.callingQueue.prompt': 'AI call queue?',
  'visitReport.callingQueue.yes': "HIja', queue",
  'visitReport.callingQueue.no': "ghobe'",
  'visitReport.callingQueue.toast': 'Lead in queue.',
  'modals.assignMissionModal.close': 'SoH',
  'modals.assignMissionModal.searchPlaceholder': 'nej (title/industry)',
  'modals.assignMissionModal.searchAriaLabel': 'nej',
  'modals.missionQuickViewModal.description': 'Mission quick legh',
  'modals.missionQuickViewModal.close': 'SoH',
  'modals.missionQuickViewModal.openDetails': 'legh details',
  'modals.missionQuickViewModal.openDetailsAria': 'Mission legh',
  'modals.leadDetailModal.close': 'SoH',
  'modals.leadDetailModal.whoIsThis': 'Who?',
  'modals.leadDetailModal.whatDoTheyNeed': 'Need?',
  'modals.leadDetailModal.whatDoISay': 'Say?',
  'modals.leadDetailModal.moreProducts': 'More products',
  'modals.regionDetailsModal.description': 'Mission legh (read-only)',
  'modals.regionDetailsModal.edit': 'ghItlh',
  'modals.regionDetailsModal.close': 'SoH',
  'modals.editRegionModal.close': 'SoH',
  'modals.editRegionModal.description': 'Time note ghItlh',
  'modals.editRegionModal.statusReadonlySrOnly': 'Status read-only',
  'modals.splitAssignmentDialog.actionLabel': 'Action wIv',
  'modals.splitAssignmentDialog.confirmButton': 'QIch',
  'modals.addAppointmentModal.companyAriaLabel': 'Company / lead',
  'modals.addAppointmentModal.commitmentConfirmed': 'Confirmed',
  'modals.rejectLead.title': 'Reject lead',
  'modals.rejectLead.closeAria': 'SoH',
  'modals.rejectLead.description': 'At least one reason.',
  'modals.rejectLead.reasonsLabel': 'Reasons',
  'modals.rejectLead.reasonsError': 'At least one reason.',
  'modals.rejectLead.otherReasonLabel': 'Other',
  'modals.rejectLead.otherReasonPlaceholder': 'Describe...',
  'modals.rejectLead.otherReasonAria': 'Other reason',
  'modals.rejectLead.otherReasonError': 'Reason vaj',
  'modals.rejectLead.cancel': "Ha'",
  'modals.rejectLead.confirm': 'Reject ({count})',
  'modals.rejectLead.reason.outOfBusiness': 'Out of business',
  'modals.rejectLead.reason.temporarilyClosed': 'Temporarily closed',
  'modals.rejectLead.reason.knownAndUnsuitable': 'Known unsuitable',
  'modals.rejectLead.reason.noInterest': 'No interest',
  'modals.rejectLead.reason.wrongContact': 'Wrong contact',
  'modals.rejectLead.reason.other': 'Other',
  'app.routes.loadingSettings': 'Loading ChoHwI...',
  'companySearch.filters.companySize': 'Company size',
  'curriculum.modules.pillar': 'Pillar',
  'curriculum.modules.selectLevel': 'Level wIv',
  'curriculum.modules.selectPillar': 'Pillar wIv',
  'curriculum.modules.selectPillarOption': 'Pillar wIv',
  'learning.lessonViewer.audioNotSupported': 'Audio not supported',
  'learning.lessonViewer.complete': 'Complete',
  'learning.lessonViewer.formatNotSupported': 'Format not supported',
  'learning.lessonViewer.videoNotSupported': 'Video not supported',
  'learning.moduleEditor.pillar': 'Pillar',
  'learning.moduleEditor.pillarLabel': 'Pillar',
  'learning.tabs.availableLessons': 'Available lessons',
  'learning.tabs.availableQuizzes': 'Available quizzes',
  'missions.management.demoPerformed': 'Demo performed',
  'missions.management.demoPerformedLabel': 'Demo performed',
  'missions.management.kpiDescription': 'DM demo revenue',
  'missions.management.moreActions': 'More actions',
  'missions.management.publish': 'Publish',
  'missions.management.searchPlaceholder': 'nej (name/region/product)',
  'mobile.layout.closeMenu': 'SoH menu',
  'mobile.layout.menu': 'Menu',
  'mobile.layout.noOfflineContent': 'No offline',
  'mobile.layout.offlinePerformance': 'Offline performance',
  'navigation.tileCard.openActions': 'Tile actions',
  'scout.preferences.badenWuerttemberg': 'Baden-Württemberg',
  'scout.preferences.thueringen': 'Thüringen',
  'scout.sprints.ciEstimate': 'CI estimate',
  'scout.sprints.estimatedMinutes': 'Estimated min',
  'styleGuide.charts.noStatusColors': 'No status colors',
  'styleGuide.confirmation': 'QIch',
  'styleGuide.description': 'Description',
  'styleGuide.statusSemantics.success': 'Qapla\' = Done',
  'tickets.list.filterPriority': 'Priority Suy',
  'ui.calendar.nextMonth': 'Next month',
  'ui.errorBoundary.returnToDashboard': 'qab Dajchaj',
  'ui.impersonation.selectImpersonation': 'Impersonation wIv',
  'ui.impersonation.selectUser': 'User wIv:',
  'ui.routingPreview.openAppleMaps': 'Apple Maps',
  'ui.routingPreview.openGoogleMaps': 'Google Maps',
  'ui.routingPreview.stopsLabel': '{{count}} stops · {{distance}} km · {{time}} min',
  'ui.routingPreview.title': 'Route preview',
  'weeklyPlanning.appointmentModal.additionalNotes': 'Additional notes',
  'weeklyPlanning.legacyAppointments.addAppointment': 'ngogh appointment',
  'scout.help.selectArticle': 'Article wIv or nej.',
  'scout.visitReport.compliance.title': 'Open reports',
  'scout.visitReport.compliance.description': '{{count}} open. Fill first.',
  'scout.visitReport.compliance.lockoutTitle': 'Reports vaj',
  'scout.visitReport.compliance.lockoutDescription': 'Fill all before continue.',
  'scout.visitReport.compliance.deferButton': 'Fill later',
  'scout.visitReport.compliance.deferCount': '{{remaining}} deferrals left',
  'scout.visitReport.compliance.noDeferrals': 'No deferrals',
  'scout.visitReport.compliance.fillReport': 'Fill report',
  'scout.visitReport.compliance.morningLockout': 'Day locked until reports.',
  'learning.lehrplan.title': 'Curriculum',
  'learning.lehrplan.subtitle': 'Curriculum goals',
  'learning.curriculumPlanning.title': 'Curriculum planning',
  'learning.curriculumPlanning.subtitle': 'Structure curriculum',
  'navigation.appOverview': "App leghqa'",
  'common.next': 'Next',
  'crm.leads': 'Leads',
  'crm.closedWon': 'Closed won',
  'crm.searchPlaceholder': 'nej leads...',
  'crm.name': 'Name',
  'crm.company': 'QeD',
  'crm.contact': 'Contact',
  'crm.source': 'Source',
  'crm.value': 'Value',
  'crm.lastContact': 'Last contact',
  'crm.viewDetails': 'legh',
  'crm.editLead': 'ghItlh lead',
  'crm.addNote': 'ngogh note',
  'crm.convertToCustomer': 'Convert customer',
  'crm.deleteLead': 'Qaw lead',
  'crm.leadDetails': 'Lead legh',
  'crm.addNewLead': "chu' lead",
  'crm.viewLeadDetails': 'legh lead',
  'crm.createNewLead': "chu' lead",
  'crm.fullName': 'Full name',
  'crm.email': 'Email',
  'crm.phone': 'Phone',
  'crm.estimatedValue': 'Estimated value',
  'crm.notes': 'Notes',
  'crm.status.new': "chu'",
  'crm.status.contacted': 'Contacted',
  'crm.status.qualified': 'Qualified',
  'crm.status.proposal': 'Proposal',
  'crm.status.negotiation': 'Negotiation',
  'crm.status.closedWon': 'Won',
  'crm.status.closedLost': 'Lost',
  'crm.source.website': 'Website',
  'crm.source.referral': 'Referral',
  'crm.source.tradeShow': 'Trade show',
  'crm.source.coldCall': 'Cold call',
  'crm.source.socialMedia': 'Social media',
  'crm.source.emailCampaign': 'Email campaign',
  'country.US': 'United States',
  'country.CA': 'Canada',
  'country.MX': 'Mexico',
  'country.GB': 'United Kingdom',
  'country.DE': 'Germany',
  'country.FR': 'France',
  'country.other': 'Other',

  // Missing keys (added from en/de; scout.dailyPlanning/hours/missions already present)
  'common.saving': 'chel...',
  'common.archive': 'Archive',
  'missions.management.decisionMakerMet': 'Decision maker met',
  'missions.management.wonAmount': 'Won amount',
  'common.active': 'Active',
  'common.archived': 'Archived',
  'common.planned': 'Planned',
  'missionControl.totalLeads': 'Total Leads',
  'missionControl.completedLeads': 'Completed Leads',
  'common.overview': 'Overview',

  'survey.contact.name': 'pong',
  'survey.contact.namePlaceholder': "pong yIngu'",
  'survey.contact.function': "Qu' / patlh",
  'survey.contact.functionPlaceholder': "Qu' yIngu'",
  'survey.contact.email': 'QIn nav',
  'survey.contact.emailPlaceholder': "QIn nav yIngu'",
  'survey.contact.phone': "ghogh HablI'",
  'survey.contact.phonePlaceholder': "ghogh HablI' mI' yIngu'",
  'survey.contact.isDecisionMaker': "wuq'a'?",

  'atc.registry.detailV2.embodiments.live': 'Live',
  'atc.registry.detailV2.embodiments.retired': 'Retired',
};
